import { render, staticRenderFns } from "./SupporterCandidate.vue?vue&type=template&id=b0096b68&scoped=true&"
import script from "./SupporterCandidate.vue?vue&type=script&lang=js&"
export * from "./SupporterCandidate.vue?vue&type=script&lang=js&"
import style0 from "./SupporterCandidate.vue?vue&type=style&index=0&id=b0096b68&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0096b68",
  null
  
)

export default component.exports